import React from 'react';
import { useNavigate } from 'react-router-dom';
import './NotFound.css';

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="notfound-page">
      <div className="notfound-card">
        <h1 className="notfound-code">404</h1>
        <p className="notfound-text">Không tìm thây trang</p>
        <button className="notfound-btn" onClick={() => navigate('/')}>Về trang chủ</button>
      </div>
    </div>
  );
};

export default NotFound;
